module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00175.8e376597.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00175.png
// module id = 905
// module chunks = 0